<header>
    <div class="header">
        <img class="mascod animate__animated animate__infinite animate__slow animate__pulse"  [ngClass]="{'animate__zoomInDown': mascodClicked}"  src="/assets/Images/Mascot_Cutted.png" alt="">
        <img class="band" src="/assets/Images/Bottom Band - Landing Page-white.png" alt="">
        <div class="header-heading heading">
                LIL<br>CHAMP’S<br>HAPPY<br>BOT
        </div>
        <span class="homeBtnRow">
            <a href="/" class="homeBtn shadow">
              <i class="fas fa-home mr-2"></i> 
              HOME
            </a>
          </span>                  
            </div>
</header>


